// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LMqX","icon":"styles_icon__2jYQX"};